<template>
  <div
    :class="['view event', { 'has-sticky' : event && event.date }]"
  >
    <loader v-if="loading" />
    <template v-else-if="event">
      <div class="view-visual">
        <img
          v-if="event && event.picture"
          :src="event.picture"
          :alt="event.title"
        />
        <img
          v-else
          src="@/assets/images/event-default.jpg"
          :alt="event.title"
        />
        <!-- <router-link to="/" class="view-backlink"> -->
        <button @click.prevent="onBack" class="view-backlink">
          <sprite
            :type="'chevron-left'"
            :width="5"
            :height="8"
          />
          Retour
        </button>

        <span
          v-if="event.stream"
          class="view-visual-label"
        >
          {{ event.headline }}
        </span>
      </div>

      <div class="view-content">
        <div class="container">
          <div class="view-content-wrapper">
            <template v-if="event">
              <span
                v-if="!event.stream"
                class="view-content-headline headline"
              >
                {{ event.headline }}
              </span>
              <h1 class="view-content-title h1">{{ event.title }}</h1>
              <span
                v-if="event.date && event.date.start"
                class="view-content-date"
              >
                 {{ getStartDate() }}
                <template v-if="event.date.end">
                  <sprite
                    :type="'chevron-right'"
                    :width="5"
                    :height="8"
                  />
                  {{ getEndDate() }}
                </template>
              </span>
              <span
                v-if="event.location"
                class="view-content-location"
              >
                {{ event.location }}
              </span>

              <span
                v-if="event.likes && event.likes > 1"
                class="view-content-likes"
              >
                <sprite
                  :type="'heart'"
                  :width="18"
                  :height="16"
                />
                {{ event.likes }} personnes adorent ce spectacle
              </span>

              <div
                ref="eventContent"
                v-html="content"
                class="view-content-text"
              />
            </template>
          </div>
        </div>
      </div>

      <div
        v-if="products && products.length > 0"
        class="view-tickets"
      >
        <div class="container">
          <h2 class="view-tickets-title">Tarifs</h2>

          <div
            v-for="(category, index) in products"
            :key="`cat${category.id}-${index}`"
          >
            <h3 class="view-tickets-subtitle">{{ category.label }}</h3>
            <ul
              class="view-tickets-list"
            >
              <li
                v-for="(price, i) in category.prices"
                :key="`event-ticket-${i}`"
                class="ticket"
              >
                <span
                  class="ticket-label"
                >
                  {{ price.label }}
                </span>
                <span class="ticket-value">{{ price.value.amount / 100 }}€</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        v-if="event.date"
        class="view-sticky"
      >
        <div class="container">
          <div class="view-sticky-left">
            <button
              class="view-sticky-action"
              @click="onShare"
            >
              Je partage
              <sprite
                :type="'share'"
                :width="16"
                :height="16"
              />
            </button>
            <button
              :class="['view-sticky-action', { 'liked': liked }]"
              @click="onLike"
            >
              J'adore
              <sprite
                :type="'heart'"
                :width="19"
                :height="17"
              />
            </button>
          </div>

          <btn @click="onClick">
            <sprite
              :type="'ticket'"
              :width="21"
              :height="21"
            />
            Réserver
          </btn>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Btn from '@/components/components/Btn.vue';
import Loader from '@/components/components/Loader.vue';
import Sprite from '@/components/components/Sprite.vue';

import moment from 'moment';

export default {
  components: {
    Btn,
    Loader,
    Sprite
  },
  computed: {
    event() {
      return this.$store.state.event.item;
    },
    content() {
      return this.$store.state.event.item && this.$store.state.event.item.description ? this.$store.state.event.item.description : null;
    },
    products() {
      return this.$store.state.event.products;
    },
    loading() {
      return this.$store.state.event.requests !== 0;
    },
    liked() {
      const index = this.$store.state.profile.pref.likes.indexOf(this.event.id);
      return index >= 0;
    }
  },
  watch: {
    content(val) {
      if (val) {
        this.$nextTick(() => {
          this.bindLinks();
        });
      }
    }
  },
  beforeMount() {
    this.$store.dispatch('event/reset');

    const { query } = this.$route;
    const { id } = this.$route.params;

    if (!this.$store.state.event.item || this.$store.state.event.item.id !== id) {
      if (query && query.stream) {
        this.$store.dispatch('event/getStreaming', id);
        this.$store.dispatch('event/getStreamingProducts', id);
        return;
      }

      this.$store.dispatch('event/get', id);
    }

    this.$store.dispatch('event/getProducts', id);
  },
  methods: {
    bindLinks() {
      if (!this.$refs.eventContent) {
        return;
      }

      this.links = [...this.$refs.eventContent.querySelectorAll('a')];

      for (let i = 0; i < this.links.length; i++) {
        const link = this.links[i];
        link.setAttribute('target', '_blank');
      }
    },
    onBack() {
      this.$router.go(-1);
    },
    getStartDate() {
      const date = this.event.date.start;
      return this.event.date.end ? moment(date).format('DD.MM') : moment(date).format('DD.MM.YYYY');
    },
    getEndDate() {
      const date = this.event.date.end;
      return moment(date).format('DD.MM.YYYY');
    },
    formatTicket(value) {
      return value.replace(/,/g, '<br>');
    },
    onShare() {
      if (!navigator.share) {
        return;
      }

      navigator.share({
        title: document.title,
        text: this.event.title,
        url: window.location.href
      });
    },
    onLike() {
      this.$store.dispatch('profile/like', {
        event: this.event.id,
        user: this.$store.state.login.logged ? this.$store.state.profile.infos.id : null,
        update: 'event',
        eventFull: this.event
      });
    },
    onClick() {
      this.$ga.event('webapp', 'book', this.event.title);
      this.$store.dispatch('basket/reset');
      this.$store.commit('basket/setId', this.event.id);
      this.$router.push('/basket');
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  position: relative;
  padding-top: 104px;

  // Visual
  // -----------------------------------------------------------------------------
  &-visual {
    @include aspect-ratio(375, 218);
    position: relative;
    background-color: $black-lighter;

    img {
      @include position(absolute, 0 null null 0);
      @include size(100%);
      object-fit: cover;
    }

    &-label {
      @include position(absolute, 21px 20px null null);
      @include padding(4px 8px);
      @include font('secondary', 'regular');
      border: 1px solid $grey-light-alternate;
      border-radius: 3px;
      background-color: $white;
      color: $primary;
      font-size: rem(16px);
      line-height: (18 / 16);
    }
  }

  &-backlink {
    @include position(absolute, 26px null null 30px);
    @include font('secondary', 'regular');
    color: $primary;
    font-size: rem(16px);
    line-height: 1;

    .svg {
      @include margin(-2px 4px null null);
      vertical-align: middle;
      fill: $primary;
    }
  }

  // Content
  // -----------------------------------------------------------------------------
  &-content {
    &:last-child {
      @include padding(null null 30px);
    }

    &-wrapper {
      @include padding(16px 16px 36px 16px);
      @include margin(-34px null 35px);
      display: flex;
      position: relative;
      z-index: 1;
      flex-direction: column;
      align-items: flex-start;
      background-color: $black-light;
    }

    .headline {
      color: rgba($white, .3);
    }

    &-title {
      @include margin(5px null null);
    }

    &-date {
      @include margin(12px null null);
      color: $primary;
      font-size: rem(18px);
      line-height: 1;

      .svg {
        @include margin(-2px null null);
        display: inline-block;
        vertical-align: middle;
        fill: $primary;
      }
    }

    &-location {
      @include margin(12px null null);
      font-size: rem(18px);
      line-height: 1;
    }

    &-likes {
      @include margin(16px null null);
      display: flex;
      align-items: center;
      font-size: rem(14px);
      line-height: (16 / 14);

      .svg {
        @include margin(-2px 7px null null);
        fill: $primary;
      }
    }

    &-text {
      @include margin(40px null null);
    }
  }

  // Tickets
  // -----------------------------------------------------------------------------
  &-tickets {
    @include padding(null null 40px);

    &-title {
      font-size: rem(26px);
      line-height: (30 / 26);

      + div .view-tickets-subtitle {
        @include margin(17px null null);
      }
    }

    &-subtitle {
      @include margin(30px null null);
      font-size: rem(20px);
      font-weight: 700;
      line-height: (24 / 20);
    }

    &-list {
      .ticket {
        @include padding(22px null);
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px dashed $grey;

        &:first-child {
          @include padding(20px null null);
        }

        &-label {
          @include font('secondary', 'regular');
          font-size: rem(20px);
          line-height: (24 / 20);
        }

        &-value {
          @include font('secondary', 'medium');
          flex-shrink: 0;
          width: 55px;
          font-size: rem(18px);
          line-height: (21 / 18);
          text-align: center;
        }
      }
    }
  }

  // Sticky bar
  &-sticky {
    @include position(fixed, null null 68px 0);
    @include padding(18px null);
    @include size(100%, auto);
    z-index: 12;
    border-top: 1px solid rgba($white, .1);
    background-color: $black-lighter;

    .container {
      @include padding(null 15px);
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &-left {
      display: flex;
    }

    &-action {
      @include padding(11px null);
      @include font('secondary', 'regular');
      display: flex;
      align-items: center;
      color: $white;
      font-size: rem(16px);
      line-height: 1;
      outline: none;

      &.liked {
        .svg {
          fill: $primary;
        }
      }

      .svg {
        @include margin(-1px null null 4px);
        fill: $white;
      }

      + .view-sticky-action {
        margin-left: 16px;
      }
    }

    &-location {
      @include margin(10px null null);
      font-size: rem(16px);
      line-height: 1;
    }

    .btn {
      @include margin(null null null 20px);
      flex-shrink: 0;
    }
  }

  // Loader
  // -----------------------------------------------------------------------------
  .loader {
    @include position(absolute, 50% null null 50%);
    transform: translate(-50%, -50%);
  }
}
</style>

<style lang="scss">
.event {
  .view-content {
    .view-content-text {
      a {
        text-decoration: underline !important;
      }

      a,
      p,
      span {
        font-family: 'Egyptienne F LT 55 Roman', sans-serif !important;
        color: $white !important;
        font-size: rem(14px) !important;
        line-height: 1.5 !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
        // margin-top: 0!important;
        // margin-bottom: 0!important;
        background: none !important;
      }
    }
  }

  &.has-sticky {
    + .footer {
      @include margin(null null 75px);
    }
  }
}
</style>
